import { render, staticRenderFns } from "./UploadProducts.vue?vue&type=template&id=2a365fb2&scoped=true&"
import script from "./UploadProducts.vue?vue&type=script&lang=js&"
export * from "./UploadProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a365fb2",
  null
  
)

export default component.exports